import { ISelectOptions, SelectField } from './form/select';

export enum GradeLevel {
  TRANSITIONAL_KINDERGARTEN = 'TK',
  KINDERGARTEN = 'K',
  FIRST = '1st',
  SECOND = '2nd',
  THIRD = '3rd',
  FOURTH = '4th',
  FIFTH = '5th',
  SIXTH = '6th',
  MIXED = 'Mixed',
}

export enum GradeRoute {
  TRANSITIONAL_KINDERGARTEN = 'TK',
  KINDERGARTEN = 'K',
  FIRST = '1',
  SECOND = '2',
  THIRD = '3',
  FOURTH = '4',
  FIFTH = '5',
  SIXTH = '6',
  MIXED = 'M',
}

export interface GradeLevelMap {
  gradeRoute: GradeRoute;
  gradeEnum: GradeLevel;
}

export class GradeLevelMap implements GradeLevelMap {
  gradeRoute: GradeRoute;
  gradeEnum: GradeLevel;

  static mapGradeLevelRouteParamToEnum(gradeRoute: string): GradeLevel {
    const gradeLevelMapper = gradeLevelMap.find(
      (gradeLevel) => gradeLevel.gradeRoute === gradeRoute,
    );

    return gradeLevelMapper?.gradeEnum;
  }

  static mapGradeLevelEnumToRoute(gradeEnum: GradeLevel): GradeRoute {
    const gradeLevelMapper = gradeLevelMap.find(
      (gradeLevel) => gradeLevel.gradeEnum === gradeEnum,
    );

    return gradeLevelMapper?.gradeRoute;
  }
}

export const gradeLevelMap: GradeLevelMap[] = [
  {
    gradeRoute: GradeRoute.TRANSITIONAL_KINDERGARTEN,
    gradeEnum: GradeLevel.TRANSITIONAL_KINDERGARTEN,
  },
  {
    gradeRoute: GradeRoute.KINDERGARTEN,
    gradeEnum: GradeLevel.KINDERGARTEN,
  },
  {
    gradeRoute: GradeRoute.FIRST,
    gradeEnum: GradeLevel.FIRST,
  },
  {
    gradeRoute: GradeRoute.SECOND,
    gradeEnum: GradeLevel.SECOND,
  },
  {
    gradeRoute: GradeRoute.THIRD,
    gradeEnum: GradeLevel.THIRD,
  },
  {
    gradeRoute: GradeRoute.FOURTH,
    gradeEnum: GradeLevel.FOURTH,
  },
  {
    gradeRoute: GradeRoute.FIFTH,
    gradeEnum: GradeLevel.FIFTH,
  },
  {
    gradeRoute: GradeRoute.SIXTH,
    gradeEnum: GradeLevel.SIXTH,
  },
];

export const gradeList: ISelectOptions[] = gradeLevelMap.map((grade) => {
  return { name: grade.gradeEnum, value: grade.gradeRoute };
});

export const gradeLevelSelectField = new SelectField({
  options: [{ name: null, value: null }, ...gradeList],
  optionName: 'name',
  optionValue: 'name',
});
